import axios from '@/axios.js';

export const usefulLinkApi = {
  getUsefulLinks(payload) {
    return axios.get(`admin/useful-links`, {
      params: payload,
    });
  },
  addUsefulLink(body) {
    return axios.post(`admin/useful-links`, body);
  },
  getUsefulLink(id) {
    return axios.get(`admin/useful-links/${id}?join=belongsTo&join=translations`);
  },
  updateUsefulLink(id, body) {
    return axios.patch(`admin/useful-links/${id}`, body);
  },
  deleteUsefulLink(id) {
    return axios.delete(`admin/useful-links/${id}`);
  },
};
